import api from "./client";
import type { NotificationKind } from "@/types/notification";

export type NotificationPreference = {
  kind: NotificationKind;
  in_app: boolean;
  email: boolean;
  sms: boolean;
  sms_allowed: boolean;
  in_app_allowed: boolean;
};
export type PreferenceChanges = Partial<Pick<NotificationPreference, "in_app" | "email" | "sms">>;

export async function getPreferences(): Promise<NotificationPreference[]> {
  return (await api.get<NotificationPreference[]>("/notifications/preferences/")).data;
}

export async function updatePreference(kind: NotificationKind, changes: PreferenceChanges) {
  return (await api.patch<NotificationPreference>(`/notifications/preferences/${kind}/`, changes)).data;
}

export type NotificationPhone = { phone: string; verified: boolean; verified_at: string | null; delivery_mode: 'live' | 'simulated' | 'unavailable' };
export const PHONE_KEY = ['notification-phone'];
export async function getNotificationPhone(): Promise<NotificationPhone> {
  return (await api.get<NotificationPhone>('/auth/notification-phone/')).data;
}
export async function requestPhoneCode(data: { phone: string; current_password: string }) {
  return (await api.post<{ challenge_id: string; delivery_status: string }>('/auth/notification-phone/request-code/', data)).data;
}
export async function verifyPhoneCode(data: { challenge_id: string; code: string }) {
  return (await api.post<NotificationPhone>('/auth/notification-phone/verify-code/', data)).data;
}
export async function removeNotificationPhone(current_password: string) {
  return (await api.post<NotificationPhone>('/auth/notification-phone/remove/', { current_password })).data;
}

export type EmergencyDraft = { building: string; title: string; body: string };
export type EmergencyOutcome = {
  id: string; building: string; building_name: string; title: string; created_at: string;
  status: "pending" | "attention" | "complete"; in_app: number; pending: number; unknown: number;
  email_sent: number; email_failed: number; email_skipped: number;
  sms_sent: number; sms_failed: number; sms_skipped: number; sms_mocked: number;
};

export async function sendEmergency({ data, key }: { data: EmergencyDraft; key: string }) {
  return (await api.post<EmergencyOutcome>("/notifications/emergencies/", data, {
    headers: { "Idempotency-Key": key },
  })).data;
}

export async function listEmergencies() {
  return (await api.get<EmergencyOutcome[]>("/notifications/emergencies/")).data;
}
